function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{clip-path:url(#SVGID_4_);}\n\t.st2{clip-path:url(#SVGID_6_);}\n\t.st3{clip-path:url(#SVGID_8_);fill:none;}\n\t.st4{clip-path:url(#SVGID_10_);fill:none;stroke:#EA002A;stroke-linecap:square;stroke-miterlimit:10;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#EA002A;stroke-miterlimit:10;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{font-family:'GothamPro-Black';}\n\t.st8{font-size:14px;}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#EA002A;stroke-miterlimit:10;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("polygon", {
  id: "SVGID_1_",
  points: "59,186.86 156.77,163.5 209.98,175.18 247.87,163.18 308.72,147.57 361.66,163.18 449.28,120.1 511.71,126.5 567.51,99 641.8,99 688.99,64.5 689,198 59,198  "
}));

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "SVGID_3_",
  x: -119,
  y: 45,
  width: 1169,
  height: 381
}));

var _ref5 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("polygon", {
  id: "SVGID_5_",
  points: "59,186.86 156.77,163.5 209.98,175.18 247.87,163.18 308.72,147.57 361.66,163.18 449.28,120.1 511.71,126.5 567.51,99 641.8,99 688.99,64.5 689,198 59,198  "
}));

var _ref6 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "SVGID_7_",
  x: 59,
  y: 64,
  width: 630,
  height: 134
}));

var _ref7 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "st3",
  points: "59,186.86 156.77,163.5 209.98,175.18 247.87,163.18 308.72,147.57 361.66,163.18 449.28,120.1 511.71,126.5 567.51,99 641.8,99 688.99,64.5 689,198 59,198  "
});

var _ref8 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "SVGID_9_",
  x: 59,
  y: 64,
  width: 630,
  height: 134
}));

var _ref9 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: -113.5,
  y1: 50.93,
  x2: 256.57,
  y2: 421
});

var _ref10 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: -89.61,
  y1: 50.93,
  x2: 280.46,
  y2: 421
});

var _ref11 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: -65.72,
  y1: 50.93,
  x2: 304.35,
  y2: 421
});

var _ref12 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: -41.83,
  y1: 50.93,
  x2: 328.24,
  y2: 421
});

var _ref13 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: -17.94,
  y1: 50.93,
  x2: 352.13,
  y2: 421
});

var _ref14 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 5.94,
  y1: 50.93,
  x2: 376.02,
  y2: 421
});

var _ref15 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 29.83,
  y1: 50.93,
  x2: 399.91,
  y2: 421
});

var _ref16 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 53.72,
  y1: 50.93,
  x2: 423.79,
  y2: 421
});

var _ref17 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 77.61,
  y1: 50.93,
  x2: 447.68,
  y2: 421
});

var _ref18 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 101.5,
  y1: 50.93,
  x2: 471.57,
  y2: 421
});

var _ref19 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 125.39,
  y1: 50.93,
  x2: 495.46,
  y2: 421
});

var _ref20 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 149.28,
  y1: 50.93,
  x2: 519.35,
  y2: 421
});

var _ref21 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 173.17,
  y1: 50.93,
  x2: 543.24,
  y2: 421
});

var _ref22 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 197.06,
  y1: 50.93,
  x2: 567.13,
  y2: 421
});

var _ref23 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 220.94,
  y1: 50.93,
  x2: 591.02,
  y2: 421
});

var _ref24 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 244.83,
  y1: 50.93,
  x2: 614.91,
  y2: 421
});

var _ref25 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 268.72,
  y1: 50.93,
  x2: 638.79,
  y2: 421
});

var _ref26 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 292.61,
  y1: 50.93,
  x2: 662.68,
  y2: 421
});

var _ref27 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 316.5,
  y1: 50.93,
  x2: 686.57,
  y2: 421
});

var _ref28 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 340.39,
  y1: 50.93,
  x2: 710.46,
  y2: 421
});

var _ref29 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 364.28,
  y1: 50.93,
  x2: 734.35,
  y2: 421
});

var _ref30 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 388.17,
  y1: 50.93,
  x2: 758.24,
  y2: 421
});

var _ref31 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 412.06,
  y1: 50.93,
  x2: 782.13,
  y2: 421
});

var _ref32 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 435.94,
  y1: 50.93,
  x2: 806.02,
  y2: 421
});

var _ref33 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 459.83,
  y1: 50.93,
  x2: 829.91,
  y2: 421
});

var _ref34 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 483.72,
  y1: 50.93,
  x2: 853.79,
  y2: 421
});

var _ref35 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 507.61,
  y1: 50.93,
  x2: 877.68,
  y2: 421
});

var _ref36 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 531.5,
  y1: 50.93,
  x2: 901.57,
  y2: 421
});

var _ref37 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 555.39,
  y1: 50.93,
  x2: 925.46,
  y2: 421
});

var _ref38 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 579.28,
  y1: 50.93,
  x2: 949.35,
  y2: 421
});

var _ref39 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 603.17,
  y1: 50.93,
  x2: 973.24,
  y2: 421
});

var _ref40 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 627.06,
  y1: 50.93,
  x2: 997.13,
  y2: 421
});

var _ref41 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 650.94,
  y1: 50.93,
  x2: 1021.02,
  y2: 421
});

var _ref42 =
/*#__PURE__*/
React.createElement("line", {
  className: "st4",
  x1: 674.83,
  y1: 50.93,
  x2: 1044.91,
  y2: 421
});

var _ref43 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_1"
}, React.createElement("polyline", {
  className: "st5",
  points: "59,198 59,186.86 156.77,163.5 209.98,175.18 247.87,163.18 308.72,147.57 361.66,163.18 449.28,120.1 511.71,126.5 567.51,99 641.8,99 688.99,64.5  "
}));

var _ref44 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u0442\\u0435\\u043A\\u0441\\u0442"
}, React.createElement("text", {
  transform: "matrix(1 0 0 1 59.4375 241.501)",
  className: "st6 st7 st8"
}, "0"), React.createElement("text", {
  transform: "matrix(1 0 0 1 258.8744 241.501)",
  className: "st6 st7 st8"
}, "10"), React.createElement("text", {
  transform: "matrix(1 0 0 1 456.1564 241.501)",
  className: "st6 st7 st8"
}, "100"), React.createElement("text", {
  transform: "matrix(1 0 0 1 653.4375 241.501)",
  className: "st6 st7 st8"
}, "1000"));

var _ref45 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u0447\\u0435\\u0440\\u0442\\u0430"
}, React.createElement("line", {
  className: "st9",
  x1: 689,
  y1: 217.5,
  x2: 59,
  y2: 217.5
}));

var _ref46 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u043E\\u0441\\u044C_\\u0432\\u0435\\u0440\\u0442"
}, React.createElement("line", {
  className: "st10",
  x1: 688.5,
  y1: 198,
  x2: 688.5,
  y2: 65
}));

var _ref47 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u043E\\u0441\\u044C_\\u0433\\u043E\\u0440"
}, React.createElement("line", {
  className: "st5",
  x1: 689,
  y1: 197.5,
  x2: 59,
  y2: 197.5
}));

var SvgGraphic = function SvgGraphic(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "50 0 645 355",
    style: {
      enableBackground: "new 0 0 785 305"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, React.createElement("g", {
    id: "\\u0448\\u0442\\u0440\\u0438\\u0445\\u0438_1_"
  }, React.createElement("g", {
    id: "\\u0448\\u0442\\u0440\\u0438\\u0445\\u0438"
  }, React.createElement("g", null, _ref3, React.createElement("clipPath", {
    id: "SVGID_2_"
  }, React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), React.createElement("g", {
    className: "st0"
  }, React.createElement("g", null, _ref4, React.createElement("clipPath", {
    id: "SVGID_4_"
  }, React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), React.createElement("g", {
    className: "st1"
  }, _ref5, React.createElement("clipPath", {
    id: "SVGID_6_"
  }, React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), React.createElement("g", {
    className: "st2"
  }, _ref6, React.createElement("clipPath", {
    id: "SVGID_8_"
  }, React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _ref7)), React.createElement("g", {
    className: "st1"
  }, _ref8, React.createElement("clipPath", {
    id: "SVGID_10_"
  }, React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42)))))), _ref43, _ref44, _ref45, _ref46, _ref47);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGraphic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/graphic.72bd36f8.svg";
export { ForwardRef as ReactComponent };